import { render, staticRenderFns } from "./PlaylistWidget.vue?vue&type=template&id=6961a610&scoped=true"
import script from "./PlaylistWidget.vue?vue&type=script&lang=js"
export * from "./PlaylistWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961a610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6961a610')) {
      api.createRecord('6961a610', component.options)
    } else {
      api.reload('6961a610', component.options)
    }
    module.hot.accept("./PlaylistWidget.vue?vue&type=template&id=6961a610&scoped=true", function () {
      api.rerender('6961a610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/PlaylistWidget.vue"
export default component.exports